import React from 'react'
import { withPrefix } from 'gatsby';
import s from './index.module.css'

const QuePasaConMiTipoFondoAlCumplir60Anios = () => {
  return (
    <>
      <div
        className={`${s.bgSection1__imagen}`}
        style={{
          backgroundImage: `url(${withPrefix('/images/woman-reading-sitting.svg')})`,
        }}
      ></div>

      <div className={`${s.bgSection1__line} `}></div>

      <div className={'containerWrap'}>
        <div className={`flex@lg`}>
          <div className={`w-100 w-50@lg`}></div>
          <div className={`w-100 w-50@lg tw-pb-4 tw-p-4@lg tw-pt-16@lg tw-pl-4@lg`}>
            <img
              src={withPrefix('/images/lamp-green.svg')}
              alt="lamp-green"
              className={`m-auto db dn@lg tw-mb-4`}
            />

            <h2 className="center left@lg font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-24@lg tw-mt-20@lg tw-pt-4@lg tw-mb-2 tw-mb-4@lg">
              ¿Qué pasa con mi tipo de fondo al cumplir 60 años?
            </h2>

            <div className="center left@lg font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg">
              <p className={`tw-mb-6`}>
                Tu fondo cambia automáticamente al tipo de fondo 1, debido a
                que estás cerca de la edad de jubilación y es necesario
                proteger tu dinero de cualquier riesgo que pueda afectar tu
                pensión. Por eso, la ley establece que al cumplir 60 años* tu
                dinero sea cambiado a un fondo más conservador.
              </p>

              <p className={`tw-mb-6`}>
                Sin embargo, si lo deseas, en el mismo mes que cumples 60 años
                puedes solicitar mantenerte en tu fondo actual, siempre y
                cuando no te encuentres en el Fondo 3<sup>(1)</sup>. Una vez
                que hayas cumplido 60 años, puedes solicitar tu cambio
                solamente al fondo 2 o fondo 0.
              </p>

              <img
                src={withPrefix('/images/woman-old-chair.svg')}
                alt="woman-old-chair"
                className={`${s.imagenBox10} m-auto db dn@lg tw-mb-4`}
              />

              <p className={'tw-f-12'}>
                (1) De acuerdo a la RESOLUCION Nº 080-98-EF/SAFP, Artículo
                37J.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default QuePasaConMiTipoFondoAlCumplir60Anios;
